import { Typography } from '@mui/material';
import { useAtomValue, useSetAtom } from 'jotai';
import { useCallback, useMemo } from 'react';
import { clientInvestmentsStateJ } from '../../../services/state/CapTableFormStateJ';
import { companyStateJ } from '../../../services/state/CompanyStateJ';
import { selectedCompanyIdProfileAtom } from '../state/UIStateJ';
import { IInvestmentGridRow, useInvestmentGridRowData } from './InvestmentGridDefs';
import { AddInvestmentsGrid } from './AddInvestmentsGrid';
import { useGetMyInvestmentsColDefs } from './useGetMyInvestmentsColDefs';

const ClientInvestmentHelperText = () => {
  const companyId = useAtomValue(selectedCompanyIdProfileAtom);
  const company = useAtomValue(companyStateJ(companyId));
  return (
    <Typography variant='subtitle1'>
      {`Please add your fund and shares purchased details, if any, for ${company?.name}.`}
    </Typography>
  );
};

export function AddYourInvestments() {
  const setClientInvestments = useSetAtom(clientInvestmentsStateJ);

  const { getInitialRowData } = useInvestmentGridRowData();
  const initialRowData = useMemo(() => getInitialRowData(), [getInitialRowData]);
  const getColDefs = useGetMyInvestmentsColDefs();
  const colDefs = useMemo(() => getColDefs(), [getColDefs]);

  const setStateToRows = useCallback(
    (rows: IInvestmentGridRow[]) => {
      setClientInvestments(rows);
    },
    [setClientInvestments]
  );

  return (
    <AddInvestmentsGrid
      initialRowData={initialRowData}
      colDefs={colDefs}
      setStateToRows={setStateToRows}
      HelpInfo={ClientInvestmentHelperText}
    />
  );
}
